// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { DBConstraint } from './DBConstraint';
import { DBTable } from './DBTable';
import { DBColumn } from './DBColumn';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 缺省约束 实体类
 * 缺省约束
 */
export class DefaultConstaint extends DBConstraint {
  /** 缺省值 : 缺省值 */
  private _defaultValue: string;

  /** 设置：缺省值 */
  public get defaultValue() {
    return this._defaultValue;
  }

  /** 获取：缺省值 */
  public set defaultValue(value: string) {
    this._defaultValue = value;
  }

  /** 数据库表 的ID */
  private _table_ID: string;

  /** 获取：数据库表 的ID */
  public get table_ID() {
    return this._table_ID;
  }

  /** 设置：数据库表 的ID */
  public set table_ID(value: string) {
    this._table_ID = value;
  }

  /** 数据库表  */
  private _table: DBTable;

  /** 获取：数据库表  */
  public get table() {
    return this._table;
  }

  /** 设置：数据库表  */
  public set table(value: DBTable) {
    this._table = value;
    if (value !== null) {
      this.table_ID = value.id;
    } else {
      this.table_ID = '';
    }
  }

  /** 列 */
  private _columns: Array<DBColumn>;

  /** 获取：列 */
  public get columns() {
    return this._columns;
  }

  /** 设置：列 */
  public set columns(value: Array<DBColumn>) {
    this._columns = value;
  }

  constructor() {
    super();
    this._defaultValue = '';
    this._table_ID = '';
    this._table = null;
    this._columns = new Array<DBColumn>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: DefaultConstaint, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.defaultValue = element.defaultValue;
      this.table_ID = element.table_ID;
      if (hasReference && element.table !== null) {
        this.table = element.table;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.defaultValue = json.DefaultValue;
    this.table_ID = json.Table_ID;
    // if (json.Table !== null) {
    //   this.table = DBTable.Create(json.Table);
    // }
    if (json.Columns && json.Columns.length > 0) {
      json.Columns.forEach((element: any) => {
        const dBColumn = DBColumn.Create(element);
        // dBColumn.defaultConstaint = this;
        this.columns.push(dBColumn);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.DefaultValue = this.defaultValue;
    json.Table_ID = this.table_ID;
    if (this.columns && this.columns.length > 0) {
      json.Columns = [];
      this.columns.forEach((element) => {
        json.Columns.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('基本属性', 'defaultValue', '缺省值', EnumDataType.String, this.defaultValue, true, '缺省值', '', '');
    return context;
  }

  static Create(json: any): DefaultConstaint {
    const defaultConstaint = new DefaultConstaint();
    defaultConstaint.Deserialize(json);
    defaultConstaint.json = json;
    return defaultConstaint;
  }
}
